import { render, staticRenderFns } from "./HistoryLog.vue?vue&type=template&id=13b89d7c&scoped=true&"
import script from "./HistoryLog.vue?vue&type=script&lang=js&"
export * from "./HistoryLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b89d7c",
  null
  
)

export default component.exports